export const TRANSACTION_CATEGORY_IDENTIFIERS = {
  computerHardware: 'computer_hardware',
  continuingEducation: 'continuing_education',
  creditCardPayments: 'credit_card_payments',
  equipment: 'equipment',
  equipmentFurniture: 'equipment_furniture',
  furniture: 'furniture',
  gifts: 'gifts',
  insuranceDental: 'insurance_dental',
  insuranceHealth: 'insurance_health',
  mealsAndEntertainment: 'meals_entertainment',
  moneyTransfer: 'money_transfer',
  officeExpenses: 'office_expenses',
  otherExpenses: 'other_expenses',
  ownersDistribution: 'owners_distribution',
  ownersInvestments: 'owners_investments',
  payrollContractors: 'payroll_contractors',
  payrollEmployeeBenefits: 'payroll_employee_benefits',
  payrollExpensesAndFees: 'payroll_expenses_fees',
  payrollPayable: 'payroll_payable',
  payrollReimbursableExpenses: 'payroll_reimbursable_expenses',
  payrollSalariesAndWages: 'payroll_salaries_wages',
  payrollSutaExpense: 'payroll_suta_expense',
  payrollTaxes: 'payroll_payroll_taxes',
  payrollWorkersCompensation: 'payroll_workers_compensation',
  professionalDevelopment: 'professional_development',
  rentAndLease: 'rent_and_lease',
  retirementContribution: 'retirement_contribution',
  taxesFederal: 'taxes_federal_taxes',
  taxesFranchise: 'taxes_franchise_taxes',
  taxesState: 'taxes_state_taxes',
  travelExpenses: 'travel_expenses',
  uniformAndLaundry: 'uniforms_laundry',
}

export enum TransactionTypes {
  INCOME = 'Income',
  EXPENSE = 'Expense',
  DEFAULT = 'Transaction',
}
